/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { nightScheduleSchema } from "./nightScheduleSchema.ts";

export const workScheduleScheduleSchema = z
	.object({
		day_of_week: z.int(),
		open_time: z.iso.time().optional(),
		close_time: z.iso.time().optional(),
		is_weekend: z.boolean(),
		night: nightScheduleSchema,
	})
	.describe("График работы точки или отделения.");
